'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _creditRequest = require('./credit-request.controller');

var _creditRequest2 = _interopRequireDefault(_creditRequest);

var _creditRequest3 = require('./credit-request.html');

var _creditRequest4 = _interopRequireDefault(_creditRequest3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  bindings: {},
  controller: _creditRequest2.default,
  controllerAs: 'creditRequest',
  template: _creditRequest4.default
};


// WEBPACK FOOTER //
// ./src/credit-request/credit-request.component.js